const typePolicies = {
  Query: {
    fields: {
      resourceTypeDetail: (_: any, { args, toReference }: any): any =>
        toReference({ __typename: 'ResourceType', id: args?.id }),
      supportCategoryDetail: (_: any, { args, toReference }: any): any =>
        toReference({ __typename: 'SupportCategory', id: args?.id })
    }
  }
} as any;

export default typePolicies;
